export enum RewardType {
  POINTS = 'POINTS',
  COUPON = 'COUPON',
  // La clé diffère volontairement de la valeur : le wire value backend est 'COUPON_POINTS'
  // (cf. GameRewardTypeEnum.COUPON_POINTS côté lb-api-v2, et les tests prono/types.spec.ts).
  // Ne pas changer la valeur en 'POINTS_COUPON' : cela casserait le contrat avec l'API.
  POINTS_COUPON = 'COUPON_POINTS',
}
